"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = exports.ProfileAddresses = exports.profileGeneralValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const constants_1 = require("@dzambalaorg/constants");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const tabs_1 = require("./tabs");
const adresses_1 = require("./adresses");
Object.defineProperty(exports, "ProfileAddresses", { enumerable: true, get: function () { return adresses_1.ProfileAddresses; } });
const general_1 = require("./general");
const subscriptions_1 = require("./subscriptions");
const settings_1 = require("./settings");
const types_1 = require("../../../types");
var validation_1 = require("./general/validation");
Object.defineProperty(exports, "profileGeneralValidationSchema", { enumerable: true, get: function () { return validation_1.profileGeneralValidationSchema; } });
const Profile = ({ service }) => {
    const { tab = tabs_1.ProfileTabs.general } = (0, react_router_1.useParams)();
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const navigate = (0, react_router_1.useNavigate)();
    const handleChange = (_event, newValue) => {
        void navigate(`/profile/${newValue === tabs_1.ProfileTabs.general ? "" : newValue}`);
    };
    const isProd = process.env.NODE_ENV === constants_1.NodeEnv.production;
    const filteredTabs = service === types_1.ServiceType.ADMIN
        ? Object.values(tabs_1.ProfileTabs)
        : Object.values(tabs_1.ProfileTabs).filter(t => t !== tabs_1.ProfileTabs.notifications);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Tabs, { value: tab, indicatorColor: "primary", textColor: "primary", onChange: handleChange, sx: { mb: 2 }, children: filteredTabs.map(tab => isProd && tab === tabs_1.ProfileTabs.addresses ? null : ((0, jsx_runtime_1.jsx)(ui_kit_1.Tabs.Tab, { label: formatMessage({ id: `pages.profile.tabs.${tab}` }), value: tab }, tab))) }), (0, jsx_runtime_1.jsx)(general_1.ProfileGeneral, { open: tab === tabs_1.ProfileTabs.general }), !isProd ? (0, jsx_runtime_1.jsx)(adresses_1.ProfileAddresses, { open: tab === tabs_1.ProfileTabs.addresses }) : null, (0, jsx_runtime_1.jsx)(subscriptions_1.ProfileSubscriptions, { open: tab === tabs_1.ProfileTabs.subscriptions }), (0, jsx_runtime_1.jsx)(settings_1.ProfileSettings, { open: tab === tabs_1.ProfileTabs.settings })] }));
};
exports.Profile = Profile;
//# sourceMappingURL=index.js.map